import React from 'react';
import { useScrollPosition } from '../hooks/useScrollPosition';
export function ScrollProgress() {
  const {
    scrollPercentage
  } = useScrollPosition();
  return <div className="fixed top-0 left-0 w-full h-1 bg-gray-200 z-50" data-id="element-326">
      <div className="h-full bg-gradient-to-r from-magenta-500 to-pink-500 transition-all duration-150" style={{
      width: `${scrollPercentage}%`
    }} data-id="element-327" />
    </div>;
}